import { CREATE_CAMPAIGN_ACTIONS, SIDEBAR_ACTIONS } from '../constants/actionsConstants';
import createCampaignModel from '../data/models/campaigns/createCampaingModel';

export const getQrCatalogs = () => async (dispatch) => {
  createCampaignModel
    .getQrCatalogs()
    .then((data) => dispatch({ type: CREATE_CAMPAIGN_ACTIONS.SET_ALL_QR_CATALOGS, data }))
    .catch((err) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', err });
    });
};

export const getGupshupCatalogs = () => async (dispatch) => {
  createCampaignModel
    .getGupshupCatalogs()
    .then((data) => dispatch({ type: CREATE_CAMPAIGN_ACTIONS.SET_ALL_GUPSHUP_CATALOGS, data }))
    .catch((err) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', err });
    });
};

export const createCampaign = (params) => async (dispatch) => {
  createCampaignModel
    .save(params)
    .then((data) => {
      dispatch({ type: CREATE_CAMPAIGN_ACTIONS.ADD_NEW_CAMPAIGN, payload: data.campaign });
      dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });

      // TODO Usar traducciones
      showtoast(data.message);
    })
    .catch(async (err) => {
      dispatch({ type: 'LOAD_DATA_FAILURE', err });
      if (err.message) {
        err.message?.campaign?.map((error) => showtoast(error));
      }
    });
};
